import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';


export default function REPPullDetailsList(props){
    //console.debug("RTS Break REPPullDetailsList");

    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));


    const columns = [
        {field: "pullDate",
            headerName:"Date",
            description:"Pull Date",
            flex:1,
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }

                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },         
        },
        {
            field: "pullType",
            headerName:"Pull Type",
            description:"Pull Entry Trype",
            flex:1
        },
        {
            field: 'confirmedFlag', 
            headerName: "Confirmed", 
            description:"Pull Confirmed", 
            flex:1,
            valueGetter: (value, row) => {
                if(value === 1){
                    return ('Yes');
                }
                else{
                    return('No');
                }
            }, 
        },           
        {
            field:"pullLength",
            headerName:"Length",
            description:"Lenght of Pull",
            flex:1,
            valueGetter: (value, row) => {
                return (
                    row.pullLength.toLocaleString() + " ft"
                )
            },
            align:"right"
        },
        {
            field: 'productName', 
            headerName: "Product", 
            description:"Product", 
            flex:3,
        },
        {
            field: 'reelSerial', 
            headerName: "Reel", 
            description:"Reel", 
            flex:1,
        },            
        {
            field: 'companyLink', 
            headerName: "Company", 
            description:"Company Link", 
            flex:1,
        },  
        {
            field: 'crewName', 
            headerName: "Crew", 
            description:"Pull Crew", 
            flex:1,
        },             
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {}
        }
        else{
            return {}
        }
    }


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    }


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid} 
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 
                }}                
            />
        </Box>
    );    
}
